/**
 * @fileoverview PATCH handler for the "/product_alerts/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import type { AllRouteEndpoints } from "../routeTypes";
import { productAlerts } from "./constants";
import type { PatchProductAlertProps } from "./types";

const patchProductAlertCacheKeys: AllRouteEndpoints[] = [productAlerts];

export const patchProductAlert = reactQueryMutationAdapter(
  patchProductAlertCacheKeys,
  ({ id, status }: PatchProductAlertProps) => {
    return fetch(`/product_alerts/${id}`, "PATCH", { status }, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
